import React, { useState } from "react";
import { useUsersContext } from "../context/users_context";
import Alert from "../components/Alert";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const { forgetPassword, showAlert } = useUsersContext();

  return (
    <div className="bg-gray-50 h-screen">
      <Navbar bg="bg-gradient-to-l from-gray-800 to-black" />
      <div className="container mx-auto">
        <div className="flex justify-center px-6 my-12">
          <div className="w-full xl:w-3/4 lg:w-11/12 flex">
            <div className="w-full bg-forget bg-no-repeat bg-center h-auto hidden lg:block lg:w-1/2 bg-cover rounded-l-lg"></div>
            <div className="w-full lg:w-1/2 bg-white p-5 rounded-lg lg:rounded-l-none">
              <div className="px-8 mb-4 text-center">
                <h3 className="pt-4 mb-2 text-2xl font-medium">
                  Forgot Your Password?
                </h3>
                <p className="mb-4 text-sm text-gray-700">
                  We get it, stuff happens. Just enter your email address below
                  and we'll send you a link to reset your password!
                </p>
              </div>
              {showAlert && <Alert />}
              <form
                className="px-8 pt-6 pb-8 mb-4 bg-white rounded"
                onSubmit={(e) => {
                  e.preventDefault();
                  forgetPassword(email);
                }}
              >
                <div className="mb-4">
                  <label
                    className="block mb-2 text-sm font-bold text-gray-700"
                    htmlFor="email"
                  >
                    Email
                  </label>
                  <input
                    className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border-gray-300 rounded-lg shadow-sm focus:border-gray-400 focus:ring-gray-400"
                    id="email"
                    type="email"
                    placeholder="Enter Email Address..."
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-6 text-center">
                  <button
                    className="w-full px-4 py-2 font-bold text-white bg-gray-500 rounded-full hover:bg-gray-700 focus:outline-none focus:shadow-outline"
                    type="submit"
                  >
                    Reset Password
                  </button>
                </div>
                <hr className="mb-6 border-t" />
                <div className="text-center">
                  <Link
                    className="inline-block text-sm text-gray-600 font-medium align-baseline hover:text-gray-800"
                    to="/signin"
                  >
                    Create an Account!
                  </Link>
                </div>
                <div className="text-center">
                  <Link
                    className="inline-block text-sm text-gray-600 font-medium align-baseline hover:text-gray-800"
                    to="/signin"
                  >
                    Already have an account? Login!
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
